import { useSelector } from "react-redux";
import "react-form-wizard-component/dist/style.css";
import React, {useEffect, useRef, useState} from "react";
import APICom from "../../utils/helpers/APICom.js";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
//servicearealat, servicearealong, serviceareamileage,tspid,isinloadmode

const AddressSearch = ({ pickupAddr2, handlePUAddrChanged, sendDataToParent  }) => {

    const { GlobalASCSData } = useSelector((store) => store.combinedata);
    
    
    const pickLatLng = useRef("");
    const liRefs = useRef([]); // Array to hold refs for each <li> PU
    const liRefPickupAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
    const [pickupAddr, setPickupAddr] = useState(pickupAddr2);
    const focusedSuggestionCheckPU = useRef(false);
    const [inputSuggestionListPU, setInputSuggestionListPU] = useState(null);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const OSRM_Username = GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceUserName").value;// (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value;
    const OSRM_Password = GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServicePassword").value; //(JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value;
    const ITCMapURL = GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceURL").value ? GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceURL").value + "autocomplete?address=": "http://itcmap.itcurves.us/api/Map/autocomplete?address=";// (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"autocomplete?address=": "http://itcmap.itcurves.us/api/Map/autocomplete?address=";

    useEffect(() => {
      setPickupAddr(pickupAddr2);
      async function wrapperAddressSearch() {
          await handlePUAddrChangedInternal();

      }
      wrapperAddressSearch();
    },[pickupAddr2]);

  

    const handlePUAddrChangedInternal = async (e)=>{
      try{
        
        let input = pickupAddr2;
        
        //setPickupAddr(input);
        
        if(input.trim().length > 8)
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", "Basic "+btoa(OSRM_Username + ":" + OSRM_Password));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = GlobalASCSData.find(dict => dict.SubTitle === "OSRMRectangleBounds").value.replace(" ", "");// (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
          let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
          // console.log(OSRMResponse);
          let SuggestedAddrArray = [];
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
          {
            SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
            {
              return item;
            });
            focusedSuggestionCheckPU.current = false;
            let suggestionsHTML = SuggestedAddrArray.length > 0? SuggestedAddrArray.map(function(item, index){
              try {
                let result = ParseGeoCodedData(item, "", index);
                liRefPickupAddressComponenet.current[index] = result;
              } catch (error) {}
            
              let LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
              liRefs.current[index] = React.createRef(); // Create a ref for each <li>
              return(
                <li ref={liRefs.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={item.formatted_address} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                      if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        // PUListRef.current.focus();
                        if(liRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex + 1) % liRefs.current.length;
                            liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if(liRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                            liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if(e.key === "Enter")
                      {
                        //handlePUSuggestionClicked(e);
                      }
                  }}
                  onClick={handlePUSuggestionClicked} key={index} value={item.formatted_address} data-virtual={LatLng}
                >
                  {item.formatted_address}
                </li>
              );
            }): "";
            // let combinedHTML = [].concat(recentAddrHTML, suggestionsHTML);
            if(suggestionsHTML !== "" && pickupAddr2 !== "")
            {
              setInputSuggestionListPU(suggestionsHTML);
            }
          //   else if(recentAddrHTML.length > 0)
          //   {
          //     setInputSuggestionListPU(recentAddrHTML);
          //   }
          }
        }
        else if(input.trim().length === 0)
        {
          setInputSuggestionListPU(""); 
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
      catch(err){console.log(err);}
    };

    const handlePUSuggestionClicked = (e)=>{
      try{  
        let selectedIndex = e.target.getAttribute('index');
        let selectedIndexAddressComponent = "";
        if(selectedIndex != undefined && selectedIndex != null)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefPickupAddressComponenet != undefined)
          {
            selectedIndexAddressComponent = liRefPickupAddressComponenet?.current[selectedIndex];
            
          }
        }
        else 
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected != undefined && _IsRecentAddressSelected != null){
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex != undefined && recentaddressindex != null){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >=0){
                
              }
            }
          }
        }
  
        // let correctDate = formatDate(selectedDateSchTime);
        //setPickupAddr(e.target.textContent);
        // setPickLatLng(e.target.dataset.virtual);
        pickLatLng.current = e.target.dataset.virtual;
        if(pickLatLng?.current != undefined){
          sendDataToParent(pickLatLng.current);
          //handleChildData = pickLatLng.current;
          // servicearealat = pickLatLng?.current.split(",")[0];
          // servicearealong = pickLatLng?.current.split(",")[1];
        }
        pickupAddr2 = e.target.textContent;
        setPickupAddr(pickupAddr2);
        // console.log(tripLatLng);
        setInputSuggestionListPU("");
      }
      catch(er){console.log(er);}
    };

  // Parsing data
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const ParseGeoCodedData = (data, Identifier, Index = 0) => {  
    var IndexLocal = 0;
    if (typeof Index == 'undefined') IndexLocal = Index;


    var StreatNum = ""; var route = ""; var Locality = ""; var Admin3 = ""; var Admin2 = ""; var Admin1 = ""; var Country = ""; var PostalCode = "";
    var establishment = ""; var neighborhood = ""; var park = ""; var premise = ""; var subpremise = ""; var sublocality = ""; var intersection = "";

    var StreatNum_short = ""; var route_short = ""; var neighborhood_short = ""; var park_short = ""; var premise_short = ""; var subpremise_short = ""; var intersection_short = "";
    var FormatedAddress = "";
      data.address_components.forEach((component) => {
        const componentType = component.types[0];
        const longName = component.long_name;
        const shortName = component.short_name;

        switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
                break;
            case 'route': route = longName; route_short = shortName;
                break;
            case 'locality': Locality = longName;
                break;
            case 'administrative_area_level_3': Admin3 = longName;
                break;
            case 'administrative_area_level_2': Admin2 = longName;
                break;
            case 'administrative_area_level_1': Admin1 = shortName;
                break;
            case 'country': Country = longName;
                break;
            case 'postal_code': PostalCode = longName;
                break;
            case 'establishment': establishment = longName;
                break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
                break;
            case 'park': park = longName; park_short = shortName;
                break;
            case 'premise': premise = longName; premise_short = shortName;
                break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
                break;
            case 'sublocality': sublocality = longName;
                break;
            case 'intersection': intersection = longName; intersection_short = shortName;
                break;
            default: break;
        }

    });
    FormatedAddress = data.formatted_address;
    if (!PostalCode) {
    }
    if (Admin1.trim() == Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
    }
    var AggregatedStreetAdddr = "";
    AggregatedStreetAdddr = (premise.trim() == "" ? "" : premise + ", ") + (subpremise.trim() == "" ? "" : subpremise + ", ") + (park.trim() == "" ? "" : park + ", ") + ((neighborhood.trim() == "" || route != "" || StreatNum != "") ? "" : neighborhood + ", ") + (intersection.trim() == "" ? "" : intersection + ", ") + StreatNum + " " + route;
    

    try {
        if (FormatedAddress.split(',').length > 0) {

            var StreetAdd = data.formatted_address.split(',')[0];
            if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1 || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1 || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
                || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1 || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1 || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) {
                AggregatedStreetAdddr = StreetAdd;
            }
        }
    } catch (CrashFailSafe) { }
    var isPoiLatLong = false;
    try {
        if (typeof data.placessearchedresult != 'undefined') {
            if (data.placessearchedresult == true) {
                isPoiLatLong = true;
            }
        }
    }
    catch (twa) { }
    var _mapSource = "unkwnSource";
    try {
        if (typeof data.mapSource != 'undefined') {
            _mapSource = data.mapSource;
        }
    } catch (setMapSrcExp) { }
    var ParsedData = {
        "Street": AggregatedStreetAdddr.trim() == "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality == "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() == "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": data.geometry.location.lat,
        "Long": data.geometry.location.lng,
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber == undefined || data.sUnitNumber == null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource

    }
    return ParsedData;
};
// ___________________


  return (
    <>  
     <input type={"search"} autoComplete="new_pass" value={pickupAddr} placeholder="Pickup Address..." title={pickupAddr} onChange={handlePUAddrChanged} 
        style={{ textOverflow:"ellipsis"}} className='text-nowrap px-1 p-0 w-100' onFocus={handlePUAddrChanged} onBlur={()=>{setTimeout(() => {
        if(!focusedSuggestionCheckPU.current)
        {
            setInputSuggestionListPU("");
        }
        }, 300);}}
        onKeyDown={(e)=>{
        if(e.key === 'ArrowDown')
        {
            e.preventDefault();
            setHighlightedIndex(-1);
            if(liRefs.current.length > 0)
            {
            if(liRefs.current[0]?.current) //check for empty references
            {
                setHighlightedIndex((prevIndex) => {
                const newIndex = (prevIndex + 1) % liRefs.current.length;
                liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                return newIndex;
                });
            }
            }
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightedIndex(-1);
            if(liRefs.current.length > 0)
            {
            if(liRefs.current[0]?.current)
            {
                setHighlightedIndex((prevIndex) => {
                const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                return newIndex;
                });
            }
            }
        }
        }}
    />
    {inputSuggestionListPU && inputSuggestionListPU !== "" ?
        <ul tabIndex={0} className="user-select-none border position-absolute px-1 bg-white" 
        style={{width:"auto", maxWidth:"350px", height:"80px", overflowY:"auto", zIndex:1000}} 
        >
        {inputSuggestionListPU}
        </ul>
    :""}
    </>
  );

}


export default AddressSearch;